export const classNames = (...classNames: string[]) => {
  return classNames.join(" ");
};
